/* eslint-disable no-restricted-globals */
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { buttonUnv, redBtn, yellowBtn } from "./Button";
import { AuthContext } from "../../shared/context/auth-context";
import { toast } from "react-toastify";

const AnimeCard = ({
  id,
  image,
  title,
  synopsis,
  score,
  openAuth,
  index,
  type,
  screenWidth,
}) => {
  const auth = useContext(AuthContext);
  const shouldLoad = useRef(true);

  const trimText = (text) => {
    const maxLength = 80;
    if (text.length > maxLength) {
      let trimmedText = text.substring(0, maxLength);
      let finalTrim = trimmedText.substring(
        0,
        Math.min(trimmedText.length, trimmedText.lastIndexOf(" "))
      );

      return finalTrim;
    } else return text;
  };

  const handleAddToWatched = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/watched/addWatched`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mal_id: id,
            title: title,
            imageUrl: image,
            synopsis: synopsis,
            score: score,
          }),
        }
      );

      if (response.status === 406) {
        toast.warn("Anime Already Added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (!response.ok) {
        toast.error("Something Went Wrong! Try again", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }

      if (response.ok) {
        toast.success(`${title} Add To Watched list `, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {}
  };

  const handleAddToWatch = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/watch/addWatch`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mal_id: id,
            title: title,
            imageUrl: image,
            synopsis: synopsis,
            score: score,
          }),
        }
      );

      if (response.status === 406) {
        toast.warn("Anime Already Added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (!response.ok) {
        toast.error("Something Went Wrong! Try again", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
      if (response.ok) {
        toast.success(`${title} Add To Watch list `, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {}
  };

  const [width, setWidth] = useState("");

  useEffect(() => {
    if (shouldLoad.current) {
      if (screenWidth < 400) {
        let int = Math.floor(screenWidth / 1.75);

        setWidth(`${int}px`);
      }
      shouldLoad.current = false;
    }
    console.log(width);
  }, [screenWidth, width]);

  return (
    <>
      <div
        key={index}
        className={`
        group flex ${
          type === "animes" ? `w-full my-[10px] ` : "w-sCardWidth "
        } h-sCardHeight md:w-cardWidth md:h-cardHeight  bg-cover bg-no-repeat bg-center sm:w-full ${
          index === 0 && type !== "animes" ? " mr-[10px] ml-[2px]" : "mx-[10px]"
        } md:m-sm bg-fill rounded-md  ring-2  ring-white`}
        style={{ backgroundImage: `url(${image || ""})` }}
      >
        <div
          className={`flex flex-col justify-between w-full h-full my-zero md:w-cardWidth md:h-cardHeight `}
        >
          <div
            className="flex justify-evenly p-[2px]  md:p-[5px] mlg:hidden lg:group-hover:flex flex-col rounded-md 
         h-sCardHeight  md:h-full bg-cover  bg-black/75  bg-center "
          >
            <Link
              to={`/anime/${id}`}
              // element={<AnimeDisplay openAuth={openAuth} />}
            >
              <div className="flex flex-col h-[70%]  md:justify-between md:h-[250px]">
                <h3 className="font-display my-[5px]  text-[21px] md:text-xm h-[100px] md:h-auto">
                  {title}
                </h3>
                <p className="hidden md:block font-body/100 my-[5px] text-[18px] md:text-sm leading-8">
                  {synopsis ? trimText(synopsis) + "..." : " "}
                </p>
                <p className="font-body/100 my-[5px] text-[18px] md:text-s">
                  Score: {score}
                </p>
              </div>
            </Link>
            {auth.isLoggedIn ? (
              <div className="relative h-[30%] flex flex-col justify-end  mb-[5px] z-30">
                <button
                  onClick={handleAddToWatched}
                  className={`${buttonUnv} ${yellowBtn} my-[5px]`}
                >
                  Add To Watched
                </button>
                <button
                  onClick={handleAddToWatch}
                  className={`${buttonUnv} bg-blue my-[5px]`}
                >
                  Add To Watch
                </button>
              </div>
            ) : (
              <div className="relative h-[50%] flex flex-col  md:justify-between mb-[5px]  z-30">
                <button
                  onClick={() => openAuth()}
                  className={`${buttonUnv} ${redBtn} text-[18px] justify-self-end my-auto w-[150px]`}
                >
                  Login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AnimeCard;
